import React from 'react';

const InlineFilterSelect = ({ label, selectedValue, selectOptions, onFilterChange }) => {

    return (
        <div>
            <div className='d-flex flex-row align-items-center justify-content-between' >
                <div className='' style={{
                    flexShrink: 0,
                    flexGrow: 0,
                    paddingRight: '0.5rem',
                    width: '70px',
                }}>{label}</div>
                <div style={{
                    flexShrink: 1,
                    flexGrow: 1,
                }} className='d-flex flex-row align-items-center justify-content-start flex-wrap' >
                    {selectOptions.map((option) => (
                        <div key={option.value} value={option.value} style={{
                            padding: '0.25rem 0.5rem',
                            margin: '0 0.25rem',
                            marginBottom: '0.5rem',
                            border: '1px solid #ced4da',
                            borderRadius: '0.25rem',
                            cursor: 'pointer',
                            backgroundColor: selectedValue === option.value ? '#007bff' : 'transparent',
                            color: selectedValue === option.value ? '#fff' : '#007bff',
                        }} onClick={() => onFilterChange(option.value)}>
                            <span>
                                {option.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InlineFilterSelect;
